import {APIStatus} from '@web/core/constants'

import {ProductBundleState} from './interfaces'

export const getInitialState = (): ProductBundleState => ({
    sequentialBundleKeys: [],
    bundleMap: {},
    subBundleMap: {},
    productMap: {},
    assignmentMap: {},
    status: {
        bundle: {
            type: APIStatus.IDLE,
        },
        assignment: {
            type: APIStatus.IDLE,
            reloadCount: 5,
        },
    },
})
